import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledAvatar = styled.div`
  display: flex;
  align-items: center;
  font-size: ${tvar('typographies.large.fontSize')};
  font-weight: ${tvar('typographies.large.fontWeight')};
`;

export const StyledImage = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  margin-right: ${tvar('space.single')};
`;
